import { all } from 'redux-saga/effects';
import cashFee from './cashFee';

export const cashFeeSaga = function* root() {
  yield all([cashFee()]);
};
